import { Component, Input, OnInit } from '@angular/core'
import { KakaoShareData } from 'src/app/interfaces/kakao'
import { LogEvent } from 'src/app/interfaces/log'
import { SocialShareType } from 'src/app/interfaces/main'
import { GeneralService } from 'src/app/services/general/general.service'
import { KakaoService } from 'src/app/services/kakao/kakao.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service'
import { QrCodeModalComponent } from '../../modals/qr-code-modal/qr-code-modal.component'

@Component({
  selector: 'app-share-linear',
  templateUrl: './share-linear.component.html',
  styleUrls: ['./share-linear.component.scss'],
})
export class ShareLinearComponent implements OnInit {
  constructor(
    private kakaoService: KakaoService,
    private generalService: GeneralService,
    private snackbarService: SnackbarService,
    private logService: LogService,
    private modalService: ModalService,
    private localeService: LocaleService
  ) {}

  @Input() shareTitle?: string = '이 테스트 공유하기'
  @Input() shareDescription: string | undefined
  @Input() title: string | undefined
  @Input() subTitle: string | undefined
  @Input() qrTitle?: string
  @Input() qrSubTitle?: string
  @Input() link: string | undefined
  @Input() buttonText: string | undefined
  @Input() imageUrl: string | undefined
  @Input() type?: string
  @Input() imageWidth: number = 375
  @Input() imageHeight: number = 210
  @Input() logShareButtonClicked?: (type: SocialShareType) => void
  qrImage = 'assets/icons/icon-qr.png'
  get isKo(): boolean {
    return this.localeService.isKo
  }
  ngOnInit() {}
  private logQrCodeModalViewed(): void {
    if (this.type) {
      this.logService.qrCodeModalViewed(this.type)
    }
  }
  async onClickQrCode(): Promise<void> {
    if (this.link) {
      const selectModal = await this.modalService.openDialog(
        QrCodeModalComponent,
        {
          title: this.qrTitle ?? this.title,
          description: this.qrSubTitle ?? this.subTitle,
          url: `${this.link.split('?')[0]}?utm_medium=qr_code`,
          borderColor: 'var(--white)',
          logModalViewed: this.logQrCodeModalViewed,
        },
        'custom-center-round-modal'
      )
      await selectModal.present()
    }
  }

  async onClickShare(type: SocialShareType): Promise<void> {
    if (this.link === undefined) {
      return
    }
    if (this.logShareButtonClicked) {
      this.logShareButtonClicked(type)
    }
    let utm = ''
    this.logService.eventLogging(LogEvent.SNS_SHARE, { from: location.pathname, type })
    switch (type) {
      case 'kakao':
        utm = `?utm_medium=kakao`
        const params: KakaoShareData = {
          title: this.title ?? '',
          description: this.subTitle ?? '',
          imageUrl: this.imageUrl ?? '',
          imageWidth: this.imageWidth,
          imageHeight: this.imageHeight,
          imageLinkUrl: `${this.link}${utm}`,
          buttonTitle: this.buttonText ?? '시작하기',
        }
        try {
          await this.kakaoService.shareQuizUsingKakao(params)
        } catch (error) {
          console.error(error)
        }
        break
      case 'qr':
        try {
          await this.onClickQrCode()
        } catch (error) {
          console.error(error)
        }
        break
      case 'x':
        utm = `?utm_medium=twitter`
        this.generalService.openInappBrowser(
          `https://twitter.com/intent/tweet?text=${this.title}&url=${
            this.link + utm
          }&hashtags=${this.localeService.getLocaleString('타입스')}`
        )
        break
      case 'link':
        utm = `?utm_medium=copy`
        await this.generalService.copy(this.link + utm)
        this.snackbarService.openSnackBar('클립보드에 링크가 복사되었습니다.')
        break
    }
  }
}
